import { Box, Container, Center, Stack, Button } from '@chakra-ui/react'
import { InfoIcon, WarningTwoIcon } from '@chakra-ui/icons';
import { Panel } from './Panel';

type MessagPanelProps = {
  type?: 'error' | 'warning' | 'info',
  title?: string,
  message?: string,
  paymentId?: string | null,
};

const onRetry = (paymentId: string) => {
  window.location.href = window.location.href.replace(window.location.hash, `#/payment/${paymentId}`);
}

export const MessagePanel = ({ type = 'info', title, message, paymentId } : MessagPanelProps) => {
  let IconComponent;

  switch (type) {
    case 'error': {
      IconComponent = <WarningTwoIcon w={16} h={16} color="red" data-testid="message-panel-error-icon" />;
      break;
    }
    case 'warning': {
      IconComponent = <WarningTwoIcon w={16} h={16} color={'#f5e633'} data-testid="message-panel-warn-icon" />;
      break;
    }
    default: {
      IconComponent = <InfoIcon w={16} h={16} color="blue.500" data-testid="message-panel-info-icon" />;
    }
  }

  return (
    <>
      <Container maxW={'xl'} bgColor={'white'} boxShadow={'none'}>
        <Center pt={6} pb={8} pl={12} pr={12}>
          {IconComponent}
        </Center>

        <Panel variant="dark" key="0">
          <Stack
            p={12} pt={10}
            direction="column"
            justify="center"
            spacing={0}
          >
            {title && (<Box fontSize={'lg'} fontWeight={'semibold'} data-testid="message-panel-title">
              { title }
            </Box>)}
            <Box fontSize={'md'}  data-testid="message-panel-message">
              { message || 'We can not process your request at the moment...' }
            </Box>
            {paymentId ? (<Box pt={4} data-testid="declined-retry">
              <Button colorScheme="pink" variant="light" fontSize={'small'} onClick={() => onRetry(paymentId) }>
                Click here to try again
              </Button>
            </Box>) : null}

          </Stack>

        </Panel>
      </Container>
    </>
  );
}
